import './StepsLine.css';
import React from 'react';
var StepsLine = function StepsLine(_ref) {
  var rtl = _ref.rtl,
    steps = _ref.steps,
    currentStepId = _ref.currentStepId,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "steps-wrapper"
  }, !!steps.length && steps.map(function (step, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: step,
      className: "step ".concat(i === currentStepId ? "step--active" : "", " ").concat(i === steps.length - 1 ? "step--last" : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: "step__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "step__name"
    }, step), /*#__PURE__*/React.createElement("div", {
      className: "step__number"
    }, i + 1)));
  })));
};
export default StepsLine;
var MAX_COMPACT_STEPS_WIDTH = "1411px";
var commonStyles = "c17lps0g";
var rtlStyles = "r1y2nt4k";
var ltrStyles = "l44b66m";